import BackendService from "@/services/BackendService";

export const namespaced = true;

export const state = {
  locations: [],
  rooms: [],
  materials: [],
  suggestions: []
};

export const mutations = {
  SET_LOCATIONS(state, { locations }) {
    state.locations = locations;
  },
  SET_ROOMS(state, { rooms }) {
    state.rooms = rooms;
  },
  SET_MATERIALS(state, { materials }) {
    state.materials = materials;
  },
  SET_SUGGESTIONS(state, suggestions) {
    state.suggestions = suggestions;
  }
};

export const actions = {
  fetchLocations({ state, commit }) {
    if (state.locations.length === 0) {
      return BackendService.getLocations()
        .then(({ data }) => {
          commit("SET_LOCATIONS", data);
        })
        .catch(error => {
          console.log("There was an error", error);
        });
    }
  },
  fetchRooms({ state, commit }) {
    if (state.rooms.length === 0) {
      return BackendService.getRooms()
        .then(({ data }) => {
          commit("SET_ROOMS", data);
        })
        .catch(error => {
          console.log("There was an error", error);
        });
    }
  },
  fetchMaterials({ state, commit }) {
    if (state.materials.length === 0) {
      return BackendService.getMaterials()
        .then(({ data }) => {
          commit("SET_MATERIALS", data);
        })
        .catch(error => {
          console.log("There was an error", error);
        });
    }
  },
  searchAppointmentSuggestions({ commit, dispatch }, payload) {
    return BackendService.searchAppointmentSuggestions(payload)
      .then(response => {
        commit("SET_SUGGESTIONS", response.data);
      })
      .catch(error => {
        console.log(error);
      });
  },
  createAppointment({commit}, payload) {
    return BackendService.confirmAppointment(payload);
  }
};

export const getters = {
  getLocation: state => () => {
    return state.locations;
  },
  getRooms: state => () => {
    return state.rooms;
  },
  getMaterials: state => () => {
    return state.materials;
  },
  getSuggestions: state => () => {
    return state.suggestions;
  }
};
